module.exports = __webpack_public_path__ + "img/企业.01f0e743.png";